/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-closing-bracket-location */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function Frame({
    aspectRatio = "4:3",
    children,
    className,
    style,
    ...rest
}) {
    const [d, n] = aspectRatio.split(':');
    const styleObj = {
        ...style,
        paddingBottom: `calc(${n} / ${d} * 100%)`
    };

    return (
        <div
            data-component="Frame"
            className={cx('sarsa-frame', className)}
            style={styleObj}
            {...rest}
        >
            {children}
        </div>
    );
}

Frame.propTypes = {
    /** If provided, the image will always conform to the aspect ratio (the
     * height will change based on the width). This value MUST be provided as
     * a string with a width followed by a colon followed by a height, such
     * as "16:9" */
    aspectRatio: PropTypes.string.isRequired,

    /** Thing being constrained to the aspect ratio */
    children: PropTypes.node,

    /** Additional class added to the outer container */
    className: PropTypes.string,

    /** Additional inline style options that will be added in to what the
     * component sets internally. Try not to use this */
    style: PropTypes.object
};
